import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  userLoginService,
  userNonceService,
  verifySignatureService,
  walletOverviewDetails
} from "../../apiService/connectWallet";

interface UserNoncePayload {
  walletAddress: string;
  networkId: string | number;
}

interface SignaturePayload {
  walletAddress: string;
  nonce: string;
  walletType: string;
  networkId: number | string;
  signature: string;
}

interface LoginPayload {
  walletAddress: string;
  networkId: string;
}

export const userNonce = createAsyncThunk(
  "vyga/userNonce",
  async (
    { walletAddress, networkId }: UserNoncePayload,
    { rejectWithValue }
  ) => {
    try {
      const result = await userNonceService(walletAddress, networkId);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const verifySignature = createAsyncThunk(
  "vyga/verifySignature",
  async (
    {
      walletAddress,
      nonce,
      walletType,
      networkId,
      signature,
    }: SignaturePayload,
    { rejectWithValue }
  ) => {
    try {
      const result = await verifySignatureService(
        walletAddress,
        nonce,
        walletType,
        networkId,
        signature
      );
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const userLogin = createAsyncThunk(
  "vyga/userLogin",
  async ({ walletAddress, networkId }: LoginPayload, { rejectWithValue }) => {
    try {
      const result = await userLoginService(walletAddress, networkId);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const walletOverview = createAsyncThunk(
  "vyga/walletOverview",
  async ({ walletAddress }: { walletAddress : string}, { rejectWithValue }) => {
    try {
      const result = await walletOverviewDetails(walletAddress);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
